import type { TradingPartnerRow } from '~/pages/AdminOcctoMaster/tabs/TradingPartner/models/types'
import type { CsvColumnDef } from '~/pages/AdminOcctoMaster/tabs/_common/models/csvExport'

/**
 * 取引先マスタタブの CSV エクスポート カラム定義
 * (spec AC-012b / design doc §5「タブ別 CSV カラム」)。
 * List レスポンスのフィールドのみを対象とし (AC-04)、詳細 (展開子行) でのみ
 * 見えるアカウント明細 (エリア / コード / 連絡先等) は含まない
 * (アカウント数のみを出力する)。
 */
export function tradingPartnerCsvColumns(): Array<
  CsvColumnDef<TradingPartnerRow>
> {
  return [
    {
      headerKey: 'page:adminOcctoMaster.tradingPartner.column.name',
      accessor: (row) => row.name,
    },
    {
      headerKey: 'page:adminOcctoMaster.tradingPartner.column.shortName',
      accessor: (row) => row.shortName,
    },
    {
      headerKey: 'page:adminOcctoMaster.tradingPartner.column.accountCount',
      accessor: (row) => String(row.accounts.length),
    },
  ]
}
